/*
* Aportes en Linea - Portal Autoservicio
* Copyright (C)
* 
* Este portal esta destinado para facilitar servicios de Aportes en Linea
* de manera sencilla e intuitiva a sus clientes.
*/
import Vue from 'vue'
import './plugins/Custom'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
